import "../styles/waitlistlandingpage.css"
import { Link } from "react-router-dom";


export default function NewsletterLandingPage() {
  return (
    <div className="success-wrapper">
      <h1 className="success-title">Danke für deine Anmeldung! 🌸</h1>
      <p className="success-text">
        Wir freuen uns sehr, dich bei Mila willkommen zu heißen.<br /> In Kürze
        erhältst du von uns deine erste Ausgabe mit Neuigkeiten, Inspirationen
        und exklusiven Einblicken – genau das Richtige für deinen Alltag. Bis
        bald und fühl dich wohl!<br /> dein ReYou-Team
      </p>
      <Link to="/" className="success-button">
        Zur Startseite
      </Link>
    </div>
  );
}